module.exports = __webpack_public_path__ + "img/ziyouwangguologo.8650109b.png";